import Image from './Image';

const AppearancesItem = ({ data }) => {
  return <Image data={data} />;
};

export default AppearancesItem;
